import { BsTrash } from "react-icons/bs";
import { HiPlus } from "react-icons/hi";

import { Product } from '../../types/product';

type ProductCardProps = {
  product: Product;
  alreadyAdded?: boolean;
  onAction: (product: Product) => void;
};

const formatPrice = (price: number) => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  return formatter.format(price);
};

export const ProductCard: React.FC<ProductCardProps> = ({
  product,
  alreadyAdded,
  onAction,
}) => {
  const handleProductClick = (product: Product) => (e: React.MouseEvent) => {
    e.preventDefault();
    onAction(product);
  };

  return (
    <div className="flex flex-col gap-1 p-2 rounded-md min-w-44 bg-white">
      <img
        className="w-full"
        alt={product.name}
        src={product.image}
      />

      <h2 className="text-xl font-medium text-gray-600">
        {product.name}
      </h2>

      <p className="text-xs text-justify text-gray-500">
        {product.description}
      </p>

      <div className="flex flex-auto items-end mt-4">
        <div className="flex flex-auto items-center justify-between">
          <span className="text-xl py-1 text-gray-500">
            {formatPrice(product.price)}
          </span>

          <button
            className="flex items-center justify-center w-10 h-10 p-1 text-sm rounded-md text-red-500 border-red-500 border border-solid"
            onClick={handleProductClick(product)}
          >
            {alreadyAdded ? <BsTrash size="24px" /> : <HiPlus size="24px" />}
          </button>
        </div>
      </div>
    </div>
  );
};
